export default {
  methods: {
    toDate(utcString) {
      if (utcString === '' || utcString === null) {
        return ''
      }
      let date = new Date(utcString);
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
    }
  }
}
